module.exports = __webpack_public_path__ + "img/129.524536b2.jpg";